<div class="feedback-view__container">
  <empathy-viewer-card>
    <ng-container slot="content">
      <div class="feedback-view__title">
        <h1 class="fs__xxxl fw__600">Thank you for your participation!</h1>
        <span class="fs__xl fw__400">We'd love to hear about your experience with this survey.</span>
      </div>
      <div class="feedback-view__content">
        <mat-button-toggle-group name="stars" hideSingleSelectionIndicator>
          @for (scale of [].constructor(5); track scale; let index = $index) {
            <mat-button-toggle [value]="index + 1" (click)="onRate(index + 1)">
              <fa-icon [icon]="feedbackForm.get('rating').value > index ? faStar : faLightStar"></fa-icon>
            </mat-button-toggle>
          }
        </mat-button-toggle-group>

        <div class="question-form__input">
          <span id="feedback__comment" class="fs__xl">Why did you choose this rating?</span>
          <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'" class="eiq-survey-textarea" [attr.aria-labelledby]="'feedback__comment'">
            <textarea
              matInput
              surveyAutoFocus
              autocomplete="off"
              cdkTextareaAutosize
              cdkAutosizeMinRows="4"
              cdkAutosizeMaxRows="7"
              placeholder="Please give as much detail as possible."
              [maxlength]="maxMessageLength"
              [formControl]="feedbackForm.get('feedback') | toFormControl"
            ></textarea>
            <mat-hint class="max-length-hint">{{ feedbackForm.get('feedback').value | charactersLeft: maxMessageLength }}</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </empathy-viewer-card>
</div>

<div @showFooter class="survey-viewer__footer">
  <empathy-viewer-progress-bar [progress]="100"></empathy-viewer-progress-bar>
  <mat-toolbar class="survey-viewer__footer__toolbar">
    <empathy-viewer-button [text]="'Finish Survey'" (clicked)="onSubmitFeedback()"></empathy-viewer-button>
  </mat-toolbar>
</div>
